import React, { useState, useEffect } from "react";
import Button from "../../Components/Button";
import { supabase } from "../../supabaseClient";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";

const YearForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [yearValue, setYearValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [originalYear, setOriginalYear] = useState(null);


  useEffect(() => {
    if (id) {
      setLoading(true);
      supabase
        .from("year")
        .select("year")
        .eq("id", id)
        .single()
        .then(({ data, error }) => {
          if (error || !data) {
            Swal.fire({
              position: "top-end",
              icon: "error",
              title: "Failed to load year",
              showConfirmButton: false,
              timer: 2500,
              toast: true,
            });
            navigate("/year");
          } else {
            // setYearValue(data.year.toString());
            setYearValue(data.year.toString());
setOriginalYear(Number(data.year));

          }
          setLoading(false);
        });
    }
  }, [id, navigate]);

  const handleSave = async (e) => {
    e.preventDefault();

    const trimmed = yearValue.trim();

    if (!trimmed || isNaN(trimmed) || trimmed.length !== 4) {
      Swal.fire({
        position: "top-end",
        icon: "warning",
        title: "Please enter a valid 4-digit year",
        showConfirmButton: false,
        timer: 2500,
        toast: true,
      });
      return;
    }

    setLoading(true);
    // 🔍 DUPLICATE YEAR CHECK (numeric)
const yearNumber = parseInt(trimmed);

const { data: existing, error: dupError } = await supabase
  .from("year")
  .select("id, year")
  .eq("year", yearNumber);

if (dupError) console.error(dupError);

// ADD MODE
if (!id) {
  if (existing && existing.length > 0) {
    setLoading(false);
    Swal.fire({
      position: "top-end",
      icon: "error",
      title: `Year "${yearNumber}" already exists`,
      showConfirmButton: false,
      timer: 2500,
      toast: true,
    });
    return;
  }
}

// EDIT MODE
// if (id) {
//   if (existing && existing.some(row => row.id !== Number(id))) {
//     setLoading(false);
//     Swal.fire({
//       position: "top-end",
//       icon: "error",
//       title: `Year "${yearNumber}" already exists`,
//       showConfirmButton: false,
//       timer: 2500,
//       toast: true,
//     });
//     return;
//   }
// }

// EDIT MODE — only check duplicates if value changed
if (id && yearNumber !== originalYear) {
  if (existing && existing.some(row => row.id !== Number(id))) {
    setLoading(false);
    Swal.fire({
      position: "top-end",
      icon: "error",
      title: `Year "${yearNumber}" already exists`,
      showConfirmButton: false,
      timer: 2500,
      toast: true,
    });
    return;
  }
}



    if (id) {
      const { error } = await supabase
        .from("year")
        .update({ year: parseInt(trimmed) })
        .eq("id", id);

      setLoading(false);

      if (error) {
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: "Failed to update year",
          showConfirmButton: false,
          timer: 2500,
          toast: true,
        });
      } else {
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Year updated successfully",
          showConfirmButton: false,
          timer: 2500,
          toast: true,
        });
        navigate("/year");
      }
    } else {
      const { error } = await supabase
        .from("year")
        .insert([{ year: parseInt(trimmed) }]);

      setLoading(false);

      if (error) {
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: "Failed to add year",
          showConfirmButton: false,
          timer: 2500,
          toast: true,
        });
      } else {
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Year added successfully",
          showConfirmButton: false,
          timer: 2500,
          toast: true,
        });
        navigate("/year");
      }
    }
  };

  return (
    <div className="min-h-screen flex flex-col p-6 bg-gray-50">
      <div className="mb-6">
        <Button
          variant="secondary"
          className="flex items-center gap-2 px-4 py-2"
          onClick={() => navigate(-1)}
        >
          <span className="text-lg">←</span> Back
        </Button>
      </div>

      <div className="flex-grow flex items-center justify-center">
        <form
          onSubmit={handleSave}
          className="space-y-6 max-w-md w-full bg-white border border-gray-300 rounded-md p-8 shadow-md"
        >
          <h1 className="text-3xl font-bold text-center text-gray-800">
            {id ? "Edit Year" : "Add Year"}
          </h1>

          <div>
            <label
              htmlFor="yearInput"
              className="block mb-2 font-semibold text-gray-700"
            >
              Enter Year (YYYY)
            </label>
            <input
              id="yearInput"
              type="number"
              value={yearValue}
              onChange={(e) => setYearValue(e.target.value)}
              placeholder="2024"
              autoFocus
              className="w-full px-4 py-3 border border-gray-300 rounded-md 
              focus:outline-none focus:ring-2 focus:ring-blue-500"
              disabled={loading}
            />
          </div>

          <div className="flex justify-center gap-4">
            <Button
              variant="primary"
              type="submit"
              disabled={loading}
              className="px-8 py-3 font-semibold text-lg"
            >
              {loading ? "Saving..." : id ? "Update" : "Save"}
            </Button>

            <Button
              variant="secondary"
              onClick={() => navigate("/year")}
              className="px-8 py-3 font-semibold text-lg"
              disabled={loading}
            >
              Cancel
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default YearForm;
